"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useModal = ({ debug = false, name = 'no name specified', isOpen = false } = {}) => {
    const [isModalOpen, setIsModalOpen] = (0, react_1.useState)(isOpen);
    const handleOpen = (0, react_1.useCallback)(() => {
        if (debug) {
            console.info('opening modal: ', { name });
        }
        setIsModalOpen(true);
    }, [debug, name]);
    const handleClose = (0, react_1.useCallback)(() => {
        if (debug) {
            console.info('closing modal: ', { name });
        }
        setIsModalOpen(false);
    }, [debug, name]);
    return { isModalOpen, handleOpen, handleClose };
};
exports.default = useModal;
